import { supabase } from '@/integrations/supabase/client';

let sessionCheckInterval: ReturnType<typeof setInterval> | null = null;

export const startSessionMonitoring = () => {
  // Check session validity every 5 minutes
  sessionCheckInterval = setInterval(async () => {
    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (error || !session) {
        console.warn('Session check failed:', error);
        return;
      }
      
      // Verify the session hasn't expired
      const expiresAt = session.expires_at;
      const now = Math.floor(Date.now() / 1000);
      
      if (expiresAt && expiresAt < now) {
        console.warn('Session has expired, signing out');
        await supabase.auth.signOut();
      }
    } catch (error) {
      console.error('Session monitoring error:', error);
    }
  }, 5 * 60 * 1000); // 5 minutes
};

export const stopSessionMonitoring = () => {
  if (sessionCheckInterval) {
    clearInterval(sessionCheckInterval);
    sessionCheckInterval = null;
  }
};
